import { ProductsForPlan } from '@tv3/store/plan/plan.model'
import { select } from '@ngrx/store'
import { selectActiveProductPlanView } from '@tv3/store/plan/plan.selectors'
import { untilDestroy } from '@tokeet-frontend/tv3-platform'

export function Subscribed(app: ProductsForPlan) {
  return function (target: any, propertyName: string, descriptor: TypedPropertyDescriptor<Function>) {
    const method = descriptor.value
    descriptor.value = async function (...params) {
      const callMethod = () => {
        method.apply(this, params)
      }

      const showAppOverview = () => {
        this.appOverview.open(app)
      }

      this.store.pipe(select(selectActiveProductPlanView(app)), untilDestroy(this)).subscribe((sub) => {
        if (!sub?.isValid) {
          showAppOverview()
        } else {
          callMethod()
        }
      })
    }
  }
}
